import { render, staticRenderFns } from "./UpdateCreateExpense.vue?vue&type=template&id=4a57fce4&lang=pug"
import script from "./UpdateCreateExpense.vue?vue&type=script&lang=ts"
export * from "./UpdateCreateExpense.vue?vue&type=script&lang=ts"
import style0 from "./UpdateCreateExpense.vue?vue&type=style&index=0&id=4a57fce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports